import { render } from "./SnippetMetaData.vue?vue&type=template&id=d41f2274&scoped=true&ts=true"
import script from "./SnippetMetaData.vue?vue&type=script&lang=ts"
export * from "./SnippetMetaData.vue?vue&type=script&lang=ts"

import "./SnippetMetaData.vue?vue&type=style&index=0&id=d41f2274&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d41f2274"]])

export default __exports__